import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Container, Row } from "reactstrap";
import {
  getClosedTickets,
  getOpenedTickets,
  getTicketDetails,
} from "src/store/ticket/saga";
import { TicketDetailDto, TicketDto } from "src/store/ticket/type";
import "./style.scss";
import Loader from "../../components/Loader";
import TicketSideBar from "./ticketLeftSidebar";
import TicketDetails from "./ticketDetail";
import TicketRightSideBar from "./ticketRightBar";
import { useAppSelector } from "src/store";

const TicketPage = () => {
  const { tab }: any = useParams();
  const loader = useAppSelector((s) => s.loading.loading);
  const location = useLocation();
  const dispatch = useDispatch();
  const [tickets, setTickets] = useState<TicketDto[]>([]);
  const [closedTickets, setClosedTicket] = useState<TicketDto[]>([]);
  const [selectedTicket, setSelectedTicket] = useState<TicketDetailDto>();

  useEffect(() => {
    tab === "all" &&
      dispatch(
        getOpenedTickets({
          payload: {
            onSuccess: (message, payload) => {
              setTickets(payload);
            },
            onError: (message) => {},
          },
        })
      );
    tab === "closed" &&
      dispatch(
        getClosedTickets({
          payload: {
            onSuccess: (message, payload) => {
              setClosedTicket(payload);
            },
            onError: (message) => {},
          },
        })
      );
  }, [dispatch, tab]);

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const ticketId = url.get("ticketId");
    if (ticketId) {
      dispatch(
        getTicketDetails({
          payload: {
            onSuccess: (message, payload) => setSelectedTicket(payload),
            onError: () => {},
          },
          id: ticketId,
        })
      );
    }
  }, [dispatch, location]);
  return (
    <React.Fragment>
      <>{loader && <Loader />}</>
      <div className="page-content">
        <Container fluid>
          <Row className="mt-2">
            <div
              className={"ticketPage " + (selectedTicket ? " bgColored" : " ")}
            >
              <TicketSideBar
                tickets={tickets}
                closeTickets={closedTickets}
                selectedTicket={selectedTicket}
              />
              {selectedTicket ? (
                <>
                  <TicketDetails
                    selectedTicket={selectedTicket}
                    setSelectedTicket={setSelectedTicket}
                  />
                  <TicketRightSideBar
                    selectedTicket={selectedTicket}
                    setSelectedTicket={setSelectedTicket}
                  />
                </>
              ) : (
                <div></div>
              )}
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TicketPage;
